module.exports = __webpack_public_path__ + "img/item_part_console.9330e514.png";